module.exports = __webpack_public_path__ + "media/4.2faa36ca.aac";